import * as axios from 'axios';
import { getAuthHeader, getUploadFileHeader } from '../utils';

export const getDetail = (loanDetailId: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-heter-iska?id=${loanDetailId}`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    });
}

export const addDetail = (model: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-heter-iska`;
    return axios.post(url, model, getUploadFileHeader())
        .then((response: any) => {
            return response.data;
        });
}

export const updateDetail = (model: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-heter-iska`;
    return axios.put(url, model, getUploadFileHeader())
        .then((response: any) => {
            return response.data;
        });
}

export const uploadSignature = (model: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-heter-iska/upload-signature`;
    return axios.put(url, model, getAuthHeader())
        .then((response: any) => {
            return response.data;
        });
}

export const skipHeterIska = (model: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-heter-iska/skip`;
    return axios.put(url, model, getAuthHeader())
        .then((response: any) => {
            return response.data;
        });
}

export const getPublicDetailByUID = (uid: any) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/loan-heter-iska/public-detail?uid=${uid}`;
    return axios.get(url, getAuthHeader()).then((response: any) => {
        return response.data;
    });
}